import { render, staticRenderFns } from "./SendAC.vue?vue&type=template&id=d66dd976"
import script from "./SendAC.vue?vue&type=script&lang=js"
export * from "./SendAC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports